import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

  const routes = [
    {
      path:"/",
      redirect: "/index/editingArticles",
    },
  {
    path: '/login',
    name: 'Login',
    component: ()=> import('../views/login'),
    meta: {
      title: '登录'
    }
  },
  {
    path:"/index",
    name: "index",
    component: ()=> import('../views/index.vue'),
    children: [
      //重定向
      { path: '/',redirect: 'editingArticles' },

      //编辑文章
      {
        path: 'editingArticles',
        name: 'editingArticles',
        component: ()=> import('../views/editingArticles.vue'),
        meta: {
          title: '百博-文章编辑'
        }
      },
      {
        path: 'completed',
        name: 'completed',
        component: ()=> import('../views/completed.vue'),
        meta: {
          title: '百博-已发文章'
        }
      },
      {
        path: 'consultInformation',
        name: 'consultInformation',
        component: ()=> import('../views/consultInformation.vue'),
        meta: {
          title: '百博-咨询信息'
        }
      }
    ]
  },
  {
    path: '/zero',
    component: ()=> import('../views/index.vue'),
    children: [
      {path: '/', redirect: 'subNews'},
      {
        path: 'subNews',
        name: 'subNews',
        component: () => import('@/views/zero/subNews'),
        meta: {
          title: '图零-文章编辑'
        }
      },
      {
        path: 'newsList',
        name: 'newsList',
        component: () => import('@/views/zero/newsList'),
        meta: {
          title: '图零-新闻列表'
        }
      },
      {
        path: 'tagsList',
        name: 'tagsList',
        component: () => import('@/views/zero/tagsList'),
        meta: {
          title: '图零-文章标签管理'
        }
      },
      {
        path: 'info',
        name: 'info',
        component: () => import('@/views/zero/consultation'),
        meta: {
          title: '图零-咨询信息'
        }
      },
    ]
  }
  
  
]

const router = new VueRouter({
  routes
})

// 路由拦截
router.beforeEach((to, from, next) => {
  let sign = window.sessionStorage.getItem('sign')
  document.title = to.meta.title
  if (sign && sign !== '') {
    // 验证通过---跳转到目标路由
    next()
  } else {
    if (to.path.indexOf('login') !== -1) {
      // 是登录---跳转到目标路由
      next()
    } else {
      // 不是登录---返回登录页
      next({
        path: '/login'
      })
    }
  }
  next();
})
router.afterEach(() => {
})

export default router
